import { Link } from 'react-router-dom'
import { Bot, Home, ArrowLeft } from 'lucide-react'
import Button from '../components/buttons/Button'
import Card from '../components/cards/Card'

const PageNotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <Card className="p-8 text-center" variant="elevated">
          {/* 404 Animation */}
          <div className="mb-8">
            <div className="relative">
              <div className="w-24 h-24 mx-auto bg-gradient-to-r from-primary-500 to-accent-500 rounded-full flex items-center justify-center mb-4 ai-float">
                <Bot className="w-12 h-12 text-white" />
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-error-500 rounded-full flex items-center justify-center ai-pulse">
                <span className="text-white text-xs font-bold">!</span>
              </div>
            </div>
            
            <h1 className="text-6xl font-bold ai-text-gradient mb-2">404</h1>
            <h2 className="text-2xl font-semibold text-white mb-4">Page Not Found</h2>
            <p className="text-secondary-400">
              Oops! The AI chatbot couldn't find the page you're looking for. 
              It might have wandered off to explore the digital universe.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Button
              as={Link}
              to="/dashboard"
              className="w-full"
              icon={Home}
            >
              Go to Dashboard
            </Button>
            
            <Button
              variant="ghost"
              onClick={() => window.history.back()}
              icon={ArrowLeft}
              className="w-full"
            >
              Go Back
            </Button>
          </div>

          {/* Fun Message */}
          <div className="mt-8 p-4 bg-secondary-700/50 rounded-lg">
            <p className="text-sm text-secondary-300">
              💡 <strong>Pro tip:</strong> Our AI is always learning. 
              Try asking it about this error - it might have some insights!
            </p>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default PageNotFound
